import { render, staticRenderFns } from "./ForgotPasswordPage.vue?vue&type=template&id=d2d3398c&scoped=true"
import script from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordPage.vue?vue&type=script&lang=js"
import style0 from "./ForgotPasswordPage.vue?vue&type=style&index=0&id=d2d3398c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2d3398c",
  null
  
)

export default component.exports